<template>
  <div class="sync">
    <h4>Update Registrations</h4>
    <p>
      <button @click="startUpdatePersonRegistrations()" :disabled="progress">Start</button>
    </p>
  </div>
</template>

<script>
import { API_URL } from '@/config'
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters('persons', ['persons']),
  },
  methods: {
    ...mapMutations('persons', ['clearList']),
    ...mapActions('persons', ['getList']),
    async startUpdatePersonRegistrations() {
      if (this.progress) return;
      await this.axios.put(API_URL + '/persons/registrations');
      this.clearList();
      await this.getList();
      this.setProgress(false);
    },
  },
}
</script>


<style lang="scss">
@import '@/assets/scss/variables.scss';
.sync {
  border-top: 1px solid lighten($primary-color, 80%);
  > p {
    padding-top: 0;
    > button {
      margin-bottom: 6px;
      &.proceeding {
        cursor: default;
        color: rgba(#fff, .5);
        background-image: -webkit-linear-gradient(
          -45deg,
          $primary-color 25%,
          lighten($primary-color, 12%) 25%,
          lighten($primary-color, 12%) 50%,
          $primary-color 50%,
          $primary-color 75%,
          lighten($primary-color, 12%) 75%,
          lighten($primary-color, 12%)
        );
        background-size: 16px 16px;
        animation: proceeding .5s linear 0s infinite;
      }

      @keyframes proceeding {
        0% { background-position: 0 0; }
        100% { background-position: 16px 16px; }
      }
    }
  }
}
</style>
